import classNames from 'classnames';
import React from 'react';

export const SelectListItem = (props: SelectListItemType & { name: string }) => {
  const { activeItem, item } = props;
  const isActive = activeItem === item.value;
  const isDisabled = item.disabled;

  return (
    <li
      {...testAnchors.useField(props.name, TEST_ANCHORS.fieldStructure.selectItem, props.item.value)}
      className={classNames({ active: isActive, disabled: isDisabled && !isActive })}
      onClick={() => !isDisabled && props.onSelect(item)}
    >
      <p>{item.label}</p>
    </li>
  );
};
